import {
  OrderCustomerInfo,
  OrderBillingAddress,
  OrderShippingAddress,
  OrderInstance
} from './types'

export const emptyCustomerInfo: OrderCustomerInfo = {
  first_name: '',
  last_name: '',
  phone_number: '',
  email: '',
  identification_number: ''
}

export const emptyShippingAddress: OrderShippingAddress = {
  country: 'Colombia',
  state: '',
  city: '',
  line_1: '',
  line_2: ''
}

export const emptyBillingAddress: OrderBillingAddress = emptyShippingAddress

export const emptyOrderInstance: OrderInstance = {
  uuid: '',
  status: 'created',
  number: '',
  notes: '',
  date: '',
  total: 0,
  customer_info: emptyCustomerInfo,
  products: [],
  shipping_address: emptyShippingAddress,
  billing_address: emptyBillingAddress
}
